import type { EntryGroup } from "~/features/cart/cart/models/CartData";
import type { CartGroup } from "../../cart/models/CartGroup";

export interface BuildTableIdInput {
  groupType: CartGroup;
  quoteNumber?: string | null;
}

export function buildTableId(input: EntryGroup): string {
  const groupType = input.groupType.toLowerCase();
  const quoteNumber = "quoteNumber" in input ? input.quoteNumber : undefined;
  const scope = quoteNumber ? `:${quoteNumber}` : "";
  return `cart-table:${groupType}${scope}`;
}

export function buildEntryRowId(productGroupNumber: number): string {
  return `cart-entry:${productGroupNumber}`;
}

export function buildLineRowId(lineItemId: number): string {
  return `cart-line:${lineItemId}`;
}
